import React from 'react';
import SimpleHeader from "../forms/SimpleHeader";
import { makeStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";



const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        margin: "auto",
        width: "50%"

    }
}));

const BaseAdHocPage = ({title, description, icon, content = [], buttons = []}) => {

    const classes = useStyles();


    const items = [];
    content.forEach(item=> {
        items.push(<Grid item xs={12}>{item}</Grid>);
    })

    const buttonItems = [];
    buttons.forEach(item=> {
        items.push(<Grid item xs={12}>{item}</Grid>);
    })

    return (

        <Box>
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs={12}>
                    <SimpleHeader title={title}
                                  description={description}
                                  icon={icon}
                    />
                </Grid>
                {items}
                {buttonItems}
            </Grid>
        </Box>

    );

}

export default BaseAdHocPage;